import { useQueries } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { NavDataKey } from './nav';

/**
 * Anh Tiến 20/10/2026: "Các tab không phân quyền, không có dữ liệu, ẩn luôn, không cho nhìn thấy".
 * Hỏi nhẹ từng danh sách (1 dòng, đúng phạm vi người xem như màn danh sách); trả về các mục đang rỗng để menu ẩn.
 * Chưa tải xong hoặc lỗi thì coi như có dữ liệu (không ẩn nhầm).
 */
const PROBES: Record<NavDataKey, () => Promise<boolean>> = {
  so3: async () => (await api.get<{ total: number }>('/so3-docs', { page: 1, pageSize: 1 })).total > 0,
  sales_orders: async () => (await api.get<{ total: number }>('/sales-orders', { page: 1, pageSize: 1 })).total > 0,
  contracts: async () => (await api.get<{ total: number }>('/contracts', { page: 1, pageSize: 1 })).total > 0,
  reservations: async () => (await api.get<{ items: unknown[] }>('/stock/reservations', {})).items.length > 0,
};

/** Trả về chuỗi các mục rỗng nối bằng dấu phẩy (ổn định giữa các lần vẽ để dùng làm phụ thuộc useMemo). */
export function useEmptyNavData(keys: NavDataKey[]): string {
  const res = useQueries({
    queries: keys.map((k) => ({ queryKey: ['nav-data', k], queryFn: PROBES[k], staleTime: 5 * 60_000 })),
  });
  return keys.filter((k, i) => res[i]?.data === false).join(',');
}
